import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type StorePickerFilterComponentProps = {
    storeFeature: string;
    active: boolean;
    onToggle: (filter: string) => void;
};

const StorePickerFilterComponent = ({
    storeFeature,
    active,
    onToggle
}: StorePickerFilterComponentProps) => {
    const { t } = useGranite();

    const handleOnChange = () => onToggle(storeFeature);

    return (
        <li className={cn("tw:flex tw:gap-2 tw:items-center")}>
            <input
                className={cn("tw:ml-1 tw:cursor-pointer")}
                id={`storePickerFilter--${storeFeature}`}
                type="checkbox"
                checked={active}
                onChange={handleOnChange}
            />
            <label
                className={cn("tw:py-1 tw:cursor-pointer tw:select-none")}
                htmlFor={`storePickerFilter--${storeFeature}`}
            >
                {t(`form.searchstore.filter.${storeFeature}`)}
            </label>
        </li>
    );
};

export { StorePickerFilterComponent };
